// @flow
import { toast } from '../store/StoreUtil';
import t from '../i18n/I18n';

export class ClipBoardUtil {
  static copyToClipBoard(text: string) {
    let textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toast(t('COPY_TO_CLIPBOARD'));
  }
}
